import { useState, useEffect, useLayoutEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { ownerWindow } from '@material-ui/core/utils';

function calculateResize(element) {
  if (!element) {
    return false;
  } // element.offsetWidth in IE creates 1px error when not overflowed
  // Example
  //          | offsetWidth | boundingRectWidth | scrollWidth
  // IE       | 95          | 95.41998291015    | 96
  // Chrome   | 95          | 95.4375           | 95
  // Firefox  | 96          | 95.5              | 96


  return Math.ceil(element.getBoundingClientRect().width) < element.scrollWidth;
}

var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default function useOverflowDetection() {
  var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _useState = useState(null),
      targetElement = _useState[0],
      setTarget = _useState[1];

  var _useState2 = useState(false),
      isOverflowed = _useState2[0],
      setOverflowed = _useState2[1]; // check on resizing


  useEnhancedEffect(function () {
    if (targetElement) {
      // Multi window support
      var win = ownerWindow(targetElement);

      var handleResize = function handleResize() {
        if (targetElement) {
          setOverflowed(calculateResize(targetElement));
        }
      };

      win.addEventListener('resize', handleResize);
      return function () {
        win.removeEventListener('resize', handleResize);
      };
    }

    return undefined;
  }, [targetElement]);
  useEnhancedEffect(function () {
    if (targetElement) {
      var handleResize = function handleResize() {
        if (targetElement) {
          setOverflowed(calculateResize(targetElement));
        }
      };

      var observer = new ResizeObserver(handleResize);
      observer.observe(targetElement.parentNode);
      return function () {
        observer.disconnect();
      };
    }

    return undefined;
  }, [targetElement]);
  useEnhancedEffect(function () {
    if (targetElement) {
      setOverflowed(calculateResize(targetElement));
    }
  }, dependencies);
  return [setTarget, isOverflowed];
}
//# sourceMappingURL=useOverflowDetection.js.map